import { KastAppClientForbiddenType } from '@kalyzee/kast-web-sdk/http';
import { useEffect } from 'react';
import { useSdkContext } from '../../contexts/sdk/context';
import { useAppNavigate } from './AppNavigate';

export const useAuthRedirects = () => {
  const sdkCtx = useSdkContext();
  const navigate = useAppNavigate();

  useEffect(() => {
    const httpClient = sdkCtx.client.getHttpClient();

    const forbiddenHandler = (type: KastAppClientForbiddenType) => {
      let reason: string | undefined;
      if (type === KastAppClientForbiddenType.INSUFFICIENT_RIGHTS) return; // 403 is handled in each scnario, not global
      if (type === KastAppClientForbiddenType.USER_IS_DISABLED) reason = 'udisabled';
      if (type === KastAppClientForbiddenType.USER_IS_BANNED) reason = 'ubanned';
      if (type === KastAppClientForbiddenType.USER_TRIAL_PERIOD_IS_OVER) reason = 'utrialperiodisover';
      if (type === KastAppClientForbiddenType.ORGANIZATION_IS_DISABLED) reason = 'odisabled';
      if (type === KastAppClientForbiddenType.ORGANIZATION_TRIAL_PERIOD_IS_OVER) reason = 'otrialperiodisover';
      if (reason) {
        navigate(`/forbidden?r=${reason}`);
      } else {
        navigate('/login');
      }
    }

    const expireHandler = () => {
      navigate('/forbidden?r=sessionexpired');
    };

    httpClient.addEventListener('forbidden', forbiddenHandler);
    httpClient.addEventListener('tokenExpire', expireHandler);

    return () => {
      httpClient.removeEventListener('forbidden', forbiddenHandler);
      httpClient.removeEventListener('tokenExpire', expireHandler);
    };
  }, [navigate, sdkCtx])
};
